export default __webpack_public_path__ + "static/media/banner-mais-desktop.7bb9b84a.png";